/** Enumerates valid promotion types. */
enum PromotionType {
  LineItemDiscount,
  CartDiscount,
  ShipmentDiscount
}

export default PromotionType;
